import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Images from "../Images";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { getSocialLinkList, subscribe } from "../Actions/v1/user";
import config from '../config/config'

function Footer() {
  const [email, setMail] = useState("");
  const [err, setErr] = useState({});
  const [socialLink, setSocialLinks] = useState([]);
  console.log("🚀 ~ Footer ~ socialLink:", socialLink)

  const subscribeMail = async () => {
    console.log("email-->", email);
    let resp = await subscribe({
      email,
    });
    console.log("🚀 ~ subscribeMail ~ resp:", resp);
    if (resp?.status) {
      setMail("");
      toast.success(resp.message);
      setErr({});
    } else {
      setErr(resp.data);
      toast.error(resp.message);
    }
  };

  const getSocialLinks = async () => {
    let resp = await getSocialLinkList();
    console.log("🚀 ~ getSocialLinks ~ resp:", resp)
    if (resp?.status) {
      setSocialLinks(resp?.data);
    }
  };

  useEffect(() => {
    getSocialLinks();
  }, []);

  return (
    <div className="footer text-center text-sm-start position-relative py-4">
      <img src={Images.elogo} className="elogo" alt="elogo" />
      <Container>
        <div className="d-flex align-items-center justify-content-center gap-3">
          <img src={Images.logo} className="footerlogo" alt="edaface" />
          <img
            src={Images.listing}
            className="footerlist_img"
            alt="edaface listing"
          />
        </div>

        <Row className="footer_page mt-4 mb-2">
          <Col sm={6} lg={3} className="mt-3 mt-lg-0">
            <h4 className="fw-600 mb-3">Company</h4>
            <Link to="">Vision</Link>
            <Link to="">Mission</Link>
            <Link to="">Core Values</Link>
            <Link to="">Branding</Link>
            <Link to="">Team</Link>
            <Link to="">Careers</Link>
            <Link to="">FAQ</Link>
          </Col>
          <Col sm={6} lg={3} className="mt-3 mt-lg-0">
            <h4 className="fw-600 mb-3">Products</h4>
            <Link to="">Eda Token</Link>
            <Link to="">Digital Clinic</Link>
            <Link to="">School of Cryptos</Link>
            <Link to="">Litepaper</Link>
            <Link to="">Whitepaper</Link>
            <Link to="">Welfare Donations</Link>
          </Col>
          <Col sm={6} lg={3} className="mt-3 mt-lg-0">
            <h4 className="fw-600 mb-3">Legal</h4>
            <Link to="">Terms of Use</Link>
            <Link to="">Privacy Policy</Link>
            <Link to="">Disclaimer</Link>
            <Link to="">Listing T&C</Link>
            <Link to="">Eda Token Policy</Link>
            <Link to="">Contact Us</Link>
          </Col>
          <Col sm={6} lg={3} className="mt-3 mt-lg-0">
            <h4 className="fw-600 mb-2">Follow us</h4>
            <h6 className="themeclr">Subscribe to our newsletter</h6>
            <div className="position-relative allarrow">
              <img
                src={Images.smallround}
                className="smallround1"
                alt="round"
              />
              <input
                onChange={(e) => setMail(e.target.value)}
                className="form-control"
                placeholder="your email"
              />
              <p onClick={() => subscribeMail()} className="mb-0 go">
                Go!
              </p>
              {err?.email && <span className="err">{err?.email}</span>}
            </div>
            <div className="mt-4 d-flex justify-content-center justify-content-sm-start socialicons gap-2">
                {
                    socialLink?.length > 0 && 
                    socialLink?.map((val)=>(
                        <Link to={val.link} target="_blank">
                        <img src={`${config.Back_URL}social/${val.logo}`} alt={val.title} />
                      </Link> 
                    ))
                }
              {/* <Link to="https://www.instagram.com/" target="_blank">
                <img src={Images.insta} alt="insta" />
              </Link>
              <Link to="https://x.com/" target="_blank">
                <img src={Images.twitter} alt="twitter" />
              </Link>
              <Link to="https://www.facebook.com/" target="_blank">
                <img src={Images.fb} alt="fb" />
              </Link>
              <Link to="https://telegram.org/" target="_blank">
                <img src={Images.tele} alt="tele" />
              </Link>
              <Link to="https://www.youtube.com/" target="_blank">
                <img src={Images.youtube} alt="youtube" />
              </Link> */}
            </div>
          </Col>
        </Row>

        <p className="mb-0 text-center copyight d_white">
          Copyright © 2022-2025. EdaFace VAC. All Rights Reserved
        </p>
      </Container>
    </div>
  );
}

export default Footer;
